import React from 'react';

import { Button } from '@components/common';

import { BaseLayout, BaseLayoutProps } from './BaseLayout';

interface AutoQualifiedProps extends Omit<BaseLayoutProps, 'headingKey' | 'textKey' | 'showConfetti' | 'actionButton'> {
  page: string;
  handleStartClick: () => void;
}

export const AutoQualified = ({ t, page, participation, account, handleStartClick }: AutoQualifiedProps) => {
  const keyPrefix = !participation ? 'requested_to_get_started' : page;
  return (
    <BaseLayout
      t={t}
      headingKey={`${keyPrefix}.heading`}
      textKey={`${keyPrefix}.text`}
      showConfetti={true}
      participation={participation}
      account={account}
      actionButton={
        <Button onClick={handleStartClick} noStyle className='btn-custom-brand'>
          {t(`${keyPrefix}.cta`)}
        </Button>
      }
    />
  );
};

export default AutoQualified;
